import { withT } from "neetocommons/react-utils";
import { Close } from "neetoicons";
import { Button, Typography } from "neetoui";

import { PANEL_TYPES } from "../../constants";

const TitleBar = withT(({ t, setVisiblePanel }) => (
  <div
    className="flex items-center justify-between p-6 pb-1"
    data-testid="elements-panel-title"
  >
    <Typography
      data-testid="elements-list-title"
      lineHeight="normal"
      style="h3"
      weight="semibold"
    >
      {t("neetoMolecules.builderSidebar.addNewElement")}
    </Typography>
    <Button
      data-testid="cancel-button"
      icon={Close}
      size="medium"
      style="text"
      onClick={() => setVisiblePanel(PANEL_TYPES.SUMMARY)}
    />
  </div>
));

export default TitleBar;
